import { render, staticRenderFns } from "./OrderReportList.vue?vue&type=template&id=f7972a42&scoped=true&"
import script from "./OrderReportList.vue?vue&type=script&lang=js&"
export * from "./OrderReportList.vue?vue&type=script&lang=js&"
import style0 from "./OrderReportList.vue?vue&type=style&index=0&id=f7972a42&lang=scss&scoped=true&"
import style1 from "./OrderReportList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7972a42",
  null
  
)

export default component.exports